

















import {Component, Vue} from "vue-property-decorator";

import axios from "axios";
import EditTemplateDialog from "@/components/EditTemplateDialog.vue";
import Template from "@/model/Template";
@Component({
  components: {EditTemplateDialog}
})
export default class Templates extends Vue {
  templates = [];
  template = new Template()
  headers = [
    {text: 'Name', value: 'name',}
  ]
  templateDialogVisible = false

  mounted() {
    this.loadTemplates()
  }
  
  public addTemplate() {
    this.template = new Template()
    this.templateDialogVisible = true
  }
  
  public templateDialogClosed() {
    this.templateDialogVisible = false
    this.loadTemplates()
  }
  
  public editTemplate(template: Template) {
    this.template = template
    this.templateDialogVisible = true
  }

  public loadTemplates() {
    let url = "/api/templates"
    axios.get(url).then((response) => {
      this.templates = response.data
    });
  }
}
